import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Politica di Rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-94" data-mp="3gg0zo4mhnzy6">
      <div className="mx-auto max-w-5xl text-center" data-id="element-95" data-mp="32o4bucrusc7l">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-96" data-mp="32pfg0dp7nlz8">
          SCIENZE PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-97" data-mp="36n3c3k2n3ksp">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-98" data-mp="3uesb1j9yv7im">
            {links.map(link => <li key={link} data-id="element-99" data-mp="37xvyhifg2ij">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-100" data-mp="3lec7k9t840dr">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-101" data-mp="29z6t68jqcdeb">
          © 2026 SCIENZE PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}